/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

var noop = (function () {});

export { noop as default };
//# sourceMappingURL=noop.js.map
